"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _spauiUtils = require("@tencent/spaui-utils");

var _spauiPortal = _interopRequireDefault(require("@tencent/spaui-portal"));

var _spauiButton = _interopRequireDefault(require("@tencent/spaui-button"));

var _spauiIcon = _interopRequireDefault(require("@tencent/spaui-icon"));

var _rcMotion = _interopRequireDefault(require("rc-motion"));

var _classnames = _interopRequireDefault(require("classnames"));

var _info = _interopRequireDefault(require("./info"));

var _drawer_props = require("./drawer_props");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * @class
 */
var Drawer =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Drawer, _PureComponent);

  function Drawer(props) {
    var _this;

    _classCallCheck(this, Drawer);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Drawer).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "handleChildrenMount", function () {
      if (_this.props.show) {
        _this.setScrollbarPadding({
          bodyScrollable: _this.props.bodyScrollable
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleClose", function () {
      if (_this.props.onClose) {
        _this.props.onClose();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleKeyDown", function (e) {
      if (_this.props.escapeKeyClosable && e.keyCode === 27) {
        e.stopPropagation();

        _this.handleClose();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleEnter", function () {
      if (_this.props.escapeKeyClosable && _this.wrapperRef && _this.wrapperRef.current && _this.wrapperRef.current.focus) {
        _this.wrapperRef.current.focus();
      }

      _this.handleChildrenMount(); // TODO:

    });

    _defineProperty(_assertThisInitialized(_this), "handleLeave", function () {
      if (_this.wrapperRef && _this.wrapperRef.current && _this.wrapperRef.current.style) {
        _this.wrapperRef.current.style.display = 'none';
      }

      _this.resetScrollbarPadding();

      if (_this.props.afterClose) {
        _this.props.afterClose();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "getScrollbarWidth", function (target) {
      if (_this.cached) {
        return _this.cached;
      }

      var scrollbarWidth = 15;

      var calcScrollbarWidth = function calcScrollbarWidth() {
        var scrollDiv = document.createElement('div');
        scrollDiv.style.width = '100px';
        scrollDiv.style.height = '100px';
        scrollDiv.style.overflow = 'scroll';
        document.body.appendChild(scrollDiv);
        scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth;
        document.body.removeChild(scrollDiv);
      };

      if (target) {
        try {
          var webkitScrollbarStyle = getComputedStyle(target, '::-webkit-scrollbar');
          var width = parseInt(webkitScrollbarStyle.width, 10);

          if (width > 0) {
            scrollbarWidth = width;
          } else {
            calcScrollbarWidth();
          }
        } catch (e) {
          calcScrollbarWidth();
        }
      } else {
        calcScrollbarWidth();
      }

      _this.cached = scrollbarWidth;
      return scrollbarWidth;
    });

    _defineProperty(_assertThisInitialized(_this), "setScrollbarPadding", function (_ref) {
      var bodyScrollable = _ref.bodyScrollable;
      var _window = window,
          innerWidth = _window.innerWidth;
      _this.bodyIsOverflowing = document.body.clientWidth < innerWidth;

      if (_this.bodyIsOverflowing && !document.body.style.paddingRight) {
        var scrollbarWidth = _this.getScrollbarWidth(document.body);

        if (scrollbarWidth !== undefined) {
          document.body.style.width = "calc(100% - ".concat(scrollbarWidth, "px)");
        }
      }

      if (bodyScrollable) {
        document.body.classList.add('spaui-scrollbar-hidden');
      } else {
        document.body.style.overflow = 'hidden';
      }
    });

    _defineProperty(_assertThisInitialized(_this), "resetScrollbarPadding", function () {
      document.body.classList.remove('spaui-scrollbar-hidden');
      document.body.style.overflow = '';
      document.body.style.width = '';
    });

    _defineProperty(_assertThisInitialized(_this), "getFooterDom", function () {
      var _this$props = _this.props,
          hideFooterDivider = _this$props.hideFooterDivider,
          hideFooter = _this$props.hideFooter,
          FooterComponent = _this$props.FooterComponent,
          FooterLeftComponent = _this$props.FooterLeftComponent,
          onSubmit = _this$props.onSubmit,
          onCancel = _this$props.onCancel,
          submitLabel = _this$props.submitLabel,
          cancelLabel = _this$props.cancelLabel,
          disabled = _this$props.disabled,
          _this$props$submitBut = _this$props.submitButtonProps,
          submitButtonProps = _this$props$submitBut === void 0 ? {} : _this$props$submitBut,
          _this$props$cancelBut = _this$props.cancelButtonProps,
          cancelButtonProps = _this$props$cancelBut === void 0 ? {} : _this$props$cancelBut,
          _this$props$loading = _this$props.loading,
          loading = _this$props$loading === void 0 ? false : _this$props$loading;
      var result = null;

      if (!hideFooter) {
        var hasCustomFooter = typeof FooterComponent !== 'undefined' && FooterComponent !== null;

        if (!hasCustomFooter) {
          result = _react["default"].createElement("div", {
            className: (0, _classnames["default"])("".concat(_this.prefix, "-footer"), {
              'no-divider': hideFooterDivider,
              'has-left': FooterLeftComponent
            })
          }, FooterLeftComponent && _react["default"].createElement("div", {
            className: (0, _classnames["default"])("".concat(_this.prefix, "-footer-inner ").concat(_this.prefix, "-footer-left"))
          }, _react["default"].createElement(FooterLeftComponent, _this.props)), _react["default"].createElement("div", {
            className: (0, _classnames["default"])("".concat(_this.prefix, "-footer-inner ").concat(_this.prefix, "-footer-right"))
          }, _react["default"].createElement(_spauiButton["default"], _extends({
            onClick: onCancel
          }, cancelButtonProps), cancelLabel), _react["default"].createElement(_spauiButton["default"], _extends({
            disabled: disabled || loading,
            displayType: "primary",
            onClick: onSubmit
          }, submitButtonProps), submitLabel)));
        } else {
          result = _react["default"].createElement(FooterComponent, _this.props);
        }
      }

      return result;
    });

    _defineProperty(_assertThisInitialized(_this), "getComponent", function () {
      var _this$props2 = _this.props,
          title = _this$props2.title,
          children = _this$props2.children,
          headerContent = _this$props2.headerContent,
          HeaderComponent = _this$props2.HeaderComponent,
          headerStyle = _this$props2.headerStyle,
          hideHeaderDivider = _this$props2.hideHeaderDivider,
          maskClosable = _this$props2.maskClosable,
          maskVisible = _this$props2.maskVisible,
          placement = _this$props2.placement,
          size = _this$props2.size,
          width = _this$props2.width,
          height = _this$props2.height,
          show = _this$props2.show,
          otherProps = _this$props2.otherProps,
          style = _this$props2.style,
          bodyClassName = _this$props2.bodyClassName,
          bodyStyle = _this$props2.bodyStyle,
          _this$props2$destroyO = _this$props2.destroyOnClose,
          destroyOnClose = _this$props2$destroyO === void 0 ? true : _this$props2$destroyO,
          zIndex = _this$props2.zIndex,
          _this$props2$leavedCl = _this$props2.leavedClassName,
          leavedClassName = _this$props2$leavedCl === void 0 ? '!spaui-hide' : _this$props2$leavedCl,
          AdditionComponent = _this$props2.AdditionComponent,
          maskMotionName = _this$props2.maskMotionName,
          maskLeavedClassName = _this$props2.maskLeavedClassName,
          contentMotionName = _this$props2.contentMotionName,
          contentLeavedClassName = _this$props2.contentLeavedClassName,
          motionAppear = _this$props2.motionAppear,
          motionEnter = _this$props2.motionEnter,
          motionLeave = _this$props2.motionLeave,
          onBodyScroll = _this$props2.onBodyScroll;

      var footerDom = _this.getFooterDom();

      var styleObj = (0, _spauiUtils.objectAssign)(style || {}, {
        display: show ? 'block' : '',
        zIndex: zIndex
      });
      var addon = null;

      if (typeof AdditionComponent !== 'undefined') {
        if ((0, _spauiUtils.isReactNode)(AdditionComponent)) {
          addon = AdditionComponent;
        } else {
          addon = _react["default"].createElement(AdditionComponent, _this.props);
        }
      }

      return _react["default"].createElement("div", _extends({}, (0, _spauiUtils.globalProps)(_this.props, {
        className: _this.prefix
      }, Drawer), {
        ref: function ref(_ref4) {
          return _this.wrapperRef = _ref4;
        },
        style: styleObj,
        tabIndex: 0,
        role: "none",
        onKeyDown: _this.handleKeyDown
      }), _react["default"].createElement(_rcMotion["default"], {
        motionName: maskMotionName || 'spaui-drawer-mask',
        visible: show && maskVisible,
        removeOnLeave: destroyOnClose,
        leavedClassName: maskLeavedClassName || leavedClassName,
        motionAppear: motionAppear,
        motionEnter: motionEnter,
        motionLeave: motionLeave
      }, function (_ref2, ref) {
        var style = _ref2.style,
            className = _ref2.className;
        return _react["default"].createElement("div", {
          className: (0, _classnames["default"])("".concat(_this.prefix, "-mask"), className),
          role: "none",
          onClick: function onClick() {
            if (maskClosable) {
              _this.handleClose();
            }
          },
          ref: ref,
          style: style
        });
      }), _react["default"].createElement(_rcMotion["default"], {
        onAppearStart: _this.handleEnter,
        onEnterStart: _this.handleEnter,
        onLeaveEnd: _this.handleLeave,
        motionName: contentMotionName || "spaui-drawer-".concat(placement),
        visible: show,
        removeOnLeave: destroyOnClose,
        leavedClassName: contentLeavedClassName || leavedClassName,
        motionAppear: motionAppear,
        motionEnter: motionEnter,
        motionLeave: motionLeave
      }, function (_ref3, ref) {
        var style = _ref3.style,
            className = _ref3.className;
        return _react["default"].createElement("div", _extends({
          className: (0, _classnames["default"])("".concat(_this.prefix, "-").concat(placement), "".concat(_this.prefix, "-").concat(size), "".concat(_this.prefix, "-inner"), className),
          style: _objectSpread({
            width: width,
            height: height
          }, style),
          ref: ref
        }, otherProps), HeaderComponent === null ? null : HeaderComponent ? _react["default"].createElement(HeaderComponent, _this.props) : _react["default"].createElement("div", {
          className: (0, _classnames["default"])("".concat(_this.prefix, "-header"), {
            'no-divider': hideHeaderDivider
          }),
          style: headerStyle
        }, _react["default"].createElement(_spauiButton["default"], {
          theme: "light",
          size: "medium",
          leftIcon: "cancel",
          className: "".concat(_this.prefix, "-header-close"),
          onClick: function onClick() {
            return _this.handleClose();
          }
        }, _react["default"].createElement(_spauiIcon["default"], {
          name: "close-bold-outlined",
          className: "".concat(_this.prefix, "-header-close-svg")
        })), _react["default"].createElement("i", {
          className: "".concat(_this.prefix, "-header-divider")
        }), title && _react["default"].createElement("div", {
          className: "spaui-drawer-title"
        }, title), headerContent && _react["default"].createElement("div", {
          className: "".concat(_this.prefix, "-header-content")
        }, headerContent)), _react["default"].createElement("div", {
          className: (0, _classnames["default"])("".concat(_this.prefix, "-body"), bodyClassName),
          style: bodyStyle,
          onScroll: onBodyScroll
        }, children), footerDom, addon);
      }));
    });

    _this.prefix = 'spaui-drawer';
    _this.wrapperRef = null;
    _this.bodyIsOverflowing = false;
    _this.cached = null;
    return _this;
  }

  _createClass(Drawer, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if ((0, _spauiUtils.isFunction)(_spauiUtils.checkCssVersion)) {
        (0, _spauiUtils.checkCssVersion)(_info["default"]);
      }
    }
  }, {
    key: "render",
    value: function render() {
      return _react["default"].createElement(_spauiPortal["default"], null, this.getComponent());
    }
  }]);

  return Drawer;
}(_react.PureComponent); // 组件标记


_defineProperty(Drawer, "propTypes", _drawer_props.propTypes);

_defineProperty(Drawer, "defaultProps", _drawer_props.defaultProps);

(0, _spauiUtils.setComponentMark)(Drawer, _info["default"]); // 组件上报

(0, _spauiUtils.reportComponentUsage)(_objectSpread({
  scope: 'spaui'
}, _info["default"])); // 用于 focus 样式只在键盘索引时生效，而在鼠标操作时不生效

(0, _spauiUtils.initFocusManager)('spaui-focus-disabled');
var _default = Drawer;
exports["default"] = _default;